import type { FC } from 'react';

export const TagIcon: FC<{
  color?: string;
}> = (props) => (
  <svg width="100%" height="100%" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.69987 4.69987H4.70653M7.00787 2H5.2C4.07989 2 3.51984 2 3.09202 2.21799C2.71569 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.07989 2 5.2V7.00787C2 7.497 2 7.7416 2.05526 7.9718C2.10425 8.17587 2.18506 8.37093 2.29472 8.54993C2.4184 8.75173 2.59135 8.92467 2.93726 9.2706L6.07059 12.4039C6.8626 13.1959 7.25867 13.592 7.71527 13.7403C8.117 13.8709 8.54967 13.8709 8.9514 13.7403C9.408 13.592 9.80407 13.1959 10.5961 12.4039L12.4039 10.5961C13.1959 9.80407 13.592 9.408 13.7403 8.9514C13.8709 8.54967 13.8709 8.117 13.7403 7.71527C13.592 7.25867 13.1959 6.8626 12.4039 6.07059L9.2706 2.93726C8.92467 2.59135 8.75173 2.4184 8.54993 2.29472C8.37093 2.18506 8.17587 2.10425 7.9718 2.05526C7.7416 2 7.497 2 7.00787 2ZM5.0332 4.69987C5.0332 4.88397 4.88397 5.0332 4.69987 5.0332C4.51577 5.0332 4.36653 4.88397 4.36653 4.69987C4.36653 4.51577 4.51577 4.36653 4.69987 4.36653C4.88397 4.36653 5.0332 4.51577 5.0332 4.69987Z"
      stroke={props.color || '#E6E6E9'}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
